import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  EventEmitter,
  Output,
  ElementRef,
} from '@angular/core';
import { TABLE_ACTION_TYPE } from '../table/fn-table.config';
import { isNull } from '../../util/check';

/**
 * Component used to upload image and show on UI.
 */
@Component({
  selector: 'fn-img-upload',
  templateUrl: 'fn-img-upload-component.html',
  encapsulation: ViewEncapsulation.None,
})
export class FnImageComponent implements OnInit {
  /**
   * member variable
   * used to show Add icon if false else show update and enable to delete Image
   */
  isFileSelected: boolean;
  /**
   * Input member variable
   * used to bind with input attribute id
   */
  @Input() elementID: string;
  /**
   * Input member variable
   * used to show Uploaded Image
   */
  @Input() cdnImgUrl: string;
  /**
   * Input member variable
   * used to show default image.
   */
  @Input() defaultUrl: string;

  /**
   * Input member variable
   * used to show Uploaded Image
   */
  @Input() eoImage: number;

  /**
 * Input member variable
 * used to disabled Add and update action
 */
  @Input() isDisabled: boolean;

  /**
   * EventEmitter emit whenever DELETE ,ADD or Update action perform
   */
  @Output() actionPerform: EventEmitter<FNImageOutputObj> = new EventEmitter();
  /**
   * FNImageOutputModel Instance Emitted by EventEmitter.
   */
  fNImageOutputModel: FNImageOutputObj = {
    callback: () => {
      this.isFileSelected =
        this.fNImageOutputModel.actionType === TABLE_ACTION_TYPE.DELETE
          ? false
          : true;
    },
    actionType: TABLE_ACTION_TYPE.ADD,
  };
  /**
   * Creates an instance of fn img upload and show component.
   * @param elementRef to get Element ny id.
   */
  constructor(private elementRef: ElementRef) {
  }

  /**
   * Implementing OnInit Event Handler to set default value for some properties of component.
   */
  ngOnInit(): void {
    this.isFileSelected = isNull(this.eoImage) ? false : true;
  }
  /**
   * Member method to open Image select window to ADD or Update Image
   * @param actionType type of action to perform
   */
  browseImage(actionType: string) {
    const inputElement = this.elementRef.nativeElement.querySelector(
      '#' + this.elementID
    );
    inputElement.click();
    this.fNImageOutputModel.actionType = actionType;
  }
  /**
   * member method
   * used to emit event when delete action performed
   */
  deleteImage() {
    this.fNImageOutputModel.actionType = TABLE_ACTION_TYPE.DELETE;
    this.actionPerform.emit(this.fNImageOutputModel);
  }
  /**
   * member method
   * called whenever user select Image and emit FNImageOutputObj when ADD or Update Action performed
   * @param files Array of files that uploaded by user.
   */
  fileChange(files: Array<File>) {
    if (files.length) {
      this.readImgData(files[0]);
      this.elementRef.nativeElement.querySelector('#' + this.elementID).value = '';
    }
  }

  readImgData(file: File): void {
    const myReader: FileReader = new FileReader();
    myReader.onloadend = (e) => {
      this.fNImageOutputModel.fnImage = {
        imgData: e.target.result,
        imgName: file.name,
        imgType: file.type,
      };
      this.actionPerform.emit(this.fNImageOutputModel);
    };
    myReader.readAsDataURL(file);
  }
}

export interface FNImageOutputObj {
  fnImage?: FnImage;
  callback: () => void;
  actionType: string;
}
export interface FnImage {
  imgData: string | ArrayBuffer;
  imgType: string;
  imgName: string;
}
